import { useSelector } from 'react-redux';
import { commonConfigurationSelector } from '../redux/reducers/app/configuration';

export const useCommonConfiguration = () => {
  return useSelector(commonConfigurationSelector);
};
